export default __webpack_public_path__ + "static/media/ups-logo.62dd14ee.svg";